module.exports = __webpack_public_path__ + "img/zizhi22.5e6b847c.png";